import type { BlockStyle } from '@/blocks/domain/types';
import type { BlockStyleDto } from '@/blocks/application/mappers/blockMapper';

export function mapStyle(dto: BlockStyleDto): BlockStyle {
  return {
    fontSize: dto.fontSize,
    ...(dto.fontSizePt != null ? { fontSizePt: dto.fontSizePt } : {}),
    fontWeight: dto.fontWeight,
    ...(dto.fontWeightValue != null ? { fontWeightValue: dto.fontWeightValue } : {}),
    textAlign: dto.textAlign,
    textColor: dto.textColor,
    backgroundColor: dto.backgroundColor,
    paddingY: dto.paddingY,
    borderTop: dto.borderTop,
    borderBottom: dto.borderBottom,
    italic: dto.italic,
    uppercase: dto.uppercase,
    previewHeight: dto.previewHeight,
    ...(dto.fontFamily ? { fontFamily: dto.fontFamily } : {}),
    ...(dto.borderColor ? { borderColor: dto.borderColor } : {})
  };
}

export function fromBlockStyle(domain: BlockStyle): BlockStyleDto {
  return {
    fontSize: domain.fontSize,
    ...(domain.fontSizePt != null ? { fontSizePt: domain.fontSizePt } : {}),
    fontWeight: domain.fontWeight,
    ...(domain.fontWeightValue != null ? { fontWeightValue: domain.fontWeightValue } : {}),
    textAlign: domain.textAlign,
    textColor: domain.textColor,
    backgroundColor: domain.backgroundColor,
    paddingY: domain.paddingY,
    borderTop: domain.borderTop,
    borderBottom: domain.borderBottom,
    italic: domain.italic,
    uppercase: domain.uppercase,
    previewHeight: domain.previewHeight,
    ...(domain.fontFamily ? { fontFamily: domain.fontFamily } : {}),
    ...(domain.borderColor ? { borderColor: domain.borderColor } : {})
  };
}
